<template lang="pug">
.modal
  header
    | セット新規作成
    <!--button(@click="close")-->
      <!--| サイズを指定せずに始める-->
      <!--img(src="@/assets/ico_arrow_right.svg")-->
  .content
    h3 取り付けたい部分の壁面のサイズを入力してください
    .sizes
      .size
        .tit 横幅
        input(type="text", v-model="width", :class="{ error: alertW }")
        .mm mm
        .limit &nbsp;
          span(v-if="alertW") 480mm - 3645mmの範囲で入力ください
      .size
        .tit 高さ
        input(type="text", v-model="height", :class="{ error: alertH }")
        .mm mm
        .limit &nbsp;
          span(v-if="alertH") 850mm - 3000mmの範囲で入力ください
      .size
        .tit 奥行
        input(type="text", v-model="depth", :class="{ error: alertD }")
        .mm mm
        .limit &nbsp;
          span(v-if="alertD") 350mm - 1000mmの範囲で入力ください
    div.area-warning
      h3 スリット・レールの色を選択してください。
      p.text-desc ※各色に対応するパーツのみ表示されます。
    ul.color
      li
        label
          input(
            type="radio",
            v-model="color",
            name="color",
            value="0",
            checked
          )
          div
            span
            | ホワイト
      li
        label
          input(type="radio", v-model="color", name="color", value="1")
          div
            span
            | ブラック
    h3 おすすめセットから選ぶ
    <!--ul.tab-->
      <!--li(v-for="(n, index) in cat",:class="{'active': n.flg == true}",@click="change(index)") {{ n.tit }}-->
    .itemsWrap
      .items
        <!--label.item(v-for="(n, i ) in setlist",v-if="Number(cnt) === Number(n.cat) || Number(n.cat) === -1")-->
        label.item(v-for="(n, i) in setlist2")
          input(type="radio", v-model="selset", name="selset", :value="i")
          span.sel
          figure
            img(:src="n.thumb")
          dl
            dt {{ n.name }}
            <!--dd {{ n.des }}-->
  footer
    button.btn.logout(v-if="config.type === 'b'", @click="alertShow") ログアウト
    button.cancel(v-if="sets.length > 0", @click="close") キャンセル
    button.btn.save(v-if="!(sets.length > 0)", @click="showSaved")
        img(src="@/assets/ico_search.svg")
        | シミュレーションの復元
    button(@click="create", :disabled="disabled()")
      | このセットではじめる
      img(src="@/assets/ico_arrow_right.svg")
  modal.alert(name="logout-alert", width="450", height="200")
    ModalAlert(@close="alertHide")
</template>

<script>
import store from '../../stores';
import axios from 'axios';
import ModalAlert from '../parts/ModalAlert.vue';
export default{
  name: 'ModalCreate',
  components: {
    ModalAlert
  },
  data () {
    return {
      timer: {},
      cnt: 0,
      selset: -1,
      width: 1680,
      height: 2400,
      depth: 650,
      setlist: [],
      setlist2: [],
      parts1: [],
      parts2: [],
      color: -1,
      alertW: false,
      alertH: false,
      alertD: false,
      cat: []
    };
  },
  props: {
    previd: Number,
    nextid: Number
  },
  computed: {
  },
  watch: {
    width (i, s) {
      if (isNaN(i)) {
        this.width = s;
      }
      if (i < 480) {
        this.alertW = true;
      } else if (i > 3645) {
        this.alertW = true;
      } else {
        this.alertW = false;
      }
    },
    height (i, s) {
      if (isNaN(i)) {
        this.height = s;
      }
      if (i < 850) {
        this.alertH = true;
      } else if (i > 3000) {
        this.alertH = true;
      } else {
        this.alertH = false;
      }
    },
    depth (i, s) {
      if (isNaN(i)) {
        this.depth = s;
      }
      if (i < 350) {
        this.alertD = true;
      } else if (i > 1000) {
        this.alertD = true;
      } else {
        this.alertD = false;
      }
    },
    color () {
      this.colorChange();
    }
  },
  methods: {
    change (num) {
      for (let prop in this.cat) {
        if (Number(prop) === Number(num)) {
          this.cat[prop].flg = true;
        } else {
          this.cat[prop].flg = false;
        }
      }
      this.cnt = num + 1;
    },
    showSaved () {
      this.$modal.show('saved-area');
      this.$emit('close');
    },
    colorChange () {
      store.commit('setView', 0);
      this.setlist2 = [];
      var col = Number(this.color);
      for (let prop in this.setlist) {
        let cat = Number(this.setlist[prop].cat);
        if (cat < 3 && col === 1) {
          this.setlist2.push(this.acopy(this.setlist[prop]));
        } else if (col === 0) {
          this.setlist2.push(this.acopy(this.setlist[prop]));
        }
      }
      this.parts2 = this.parts1;
      for (let prop in this.partsitems) {
        let cat = Number(this.partsitems[prop].cat);
        let itm = this.acopy(this.partsitems[prop]);
        if (cat >= 12 && col === 0) {
          itm.display = true;
        } else if (cat < 11 && col === 1) {
          itm.display = false;
        }
        this.parts2.push(itm);
      }
      store.commit('setPartsitems', this.parts2);

      store.commit('setColor', col);

      setTimeout(function () {
        store.commit('setView', 1);
      }, 1000);
    },
    // sizeChange (num, e) {
    //   let n = 0;
    //   if (num === 1) {
    //     n = Number(e.target.value) >= 48 ? Number(e.target.value) : 48;
    //     this.width = n;
    //   } else if (num === 2) {
    //     n = Number(e.target.value) >= 80 ? Number(e.target.value) : 80;
    //     this.height = n;
    //   } else if (num === 3) {
    //     n = Number(e.target.value) >= 30 ? Number(e.target.value) : 30;
    //     this.depth = n;
    //   }
    // },
    create () {
      let me = this;
      if (document.querySelector('[name="selset"]:checked')) {
        let num = document.querySelector('[name="selset"]:checked').value;
        let obj = this.acopy(this.setlist[num]);
        obj.id = this.nextid;
        obj.space = [Number(this.width), Number(this.height), Number(this.depth)];
        obj.left = 1.5;
        obj.color = Number(this.color);
        store.commit('setcheckColor', obj.color);
        obj.alert = false;
        obj.fix = [];
        // スリットの長さ決める
        for (let prop in this.slititems) {
          let pos1 = 1000000;
          let pos2 = 1000000;
          pos1 = Number(this.slititems[prop].pos);
          if (this.slititems[Number(prop) + 1] !== undefined) {
            pos2 = Number(this.slititems[Number(prop) + 1].pos);
          }
          let ht = obj.space[1] / 10;
          // 床上を含めて計算
          if (pos1 + obj.size[3] <= ht && pos2 + obj.size[3] > ht) {
            if (obj.cat === 4) { // ランドリーだけ高さ70cm
              obj.size[1] = 70;
              obj.size[3] = ((obj.space[1] - obj.size[4]) / 10) - 80;
            } else {
              obj.size[1] = pos1;
            }
          }
        }
        // スパンを決める
        let interval = [];
        let spanitems = this.spanitems[obj.span].item;
        for (let prop in spanitems) {
          if (obj.space[0] >= spanitems[prop].start && obj.space[0] <= spanitems[prop].end) {
            interval = spanitems[prop].interval;
          }
        }
        let wd = 0;
        let sary = [];
        for (let prop in obj.slits) {
          if (interval[Number(prop) - 1] !== undefined || Number(prop) === 0) {
            let pos = 0;
            if (Number(prop) === 0) {
              pos = 0;
            } else {
              pos = interval[prop - 1] / 10;
            }
            wd += pos;
            obj.slits[prop].pos = wd;
            obj.slits[prop].display = true;
            sary.push(this.acopy(obj.slits[prop]));
          }
        }
        obj.size[0] = wd;
        sary[sary.length - 1].item = [];
        obj.slits = sary;
        // それぞれ商品を整形
        for (let prop in obj.slits) {
          for (let prop2 in obj.slits[prop].item) {
            let iid = obj.slits[prop].item[prop2].code;
            // カラー・ブラック選択で商品変更
            if (obj.color === 1) {
              if (iid.indexOf('TP') !== -1 || iid.indexOf('TS') !== -1) {
                iid = iid.replace('E', 'M1B');
              }
            }
            if (iid.indexOf('LT') !== -1 && this.config.type === 'b') {
              let ick = this.checkItem(iid);
              if (ick.item.w === undefined) {
                iid = iid.replace('FA', 'FB');
                iid = iid.replace('FWA', 'FWB');
              }
            }
            let citem = this.checkItem(iid);
            let item = citem.item;
            let dat = citem.dat;
            let y = obj.slits[prop].item[prop2].y;
            let display = true;

            obj.slits[prop].item[prop2] = item;
            obj.slits[prop].item[prop2].dat = {};
            obj.slits[prop].item[prop2].dat.item = dat;

            var ary = [];
            for (let prop3 in obj.slits[prop].item[prop2].dat.item) {
              let w = obj.slits[prop].item[prop2].dat.item[prop3].w;
              ary[w] = this.acopy(obj.slits[prop].item[prop2].dat.item[prop3]);
            }
            obj.slits[prop].item[prop2].ary = ary;

            obj.slits[prop].item[prop2].y = Number(y) - 1;
            obj.slits[prop].item[prop2].display = display;
          }
          obj.slits[prop].floor = [];
        }
        // シューズ選択＆スリットが70cmのとき
        if (obj.size[1] === 70 && Number(num) === 3) {
          for (let prop in obj.slits) {
            obj.slits[prop].item.pop();
            obj.slits[prop].item.pop();
          }
        }
        if (this.$store.state.simulationInfo.id) {
          this.$store.state.arraybk.push(obj);
          var idx = this.$store.state.simulationInfo.simulation_detail.length + 1;
        }
        this.sets.push(obj);
        store.commit('setId', this.nextid);
        store.commit('setSets', this.sets);
        store.commit('setArraybk', this.$store.state.arraybk);
        store.commit('setIdx', idx);
        if (this.nextid !== Number(this.$route.params.id)) {
          this.$router.push({ path: '/' + this.nextid });
        }
        clearTimeout(me.timer);
        me.timer = setTimeout(function () {
          me.sets.splice(me.nextid - 1, 1, me.sets[me.nextid - 1]);
          me.$emit('close');
        }, 100);
      }
    },
    checkItem (id) {
      let dat = {};
      let item = {};
      for (let prop in this.partsitems) {
        let itm = this.partsitems[prop].item;
        let cat = this.partsitems[prop].cat;
        for (let prop2 in itm) {
          if (id === itm[prop2].code) {
            item = this.acopy(itm[prop2]);
            item.cat = cat;
            dat = this.acopy(itm);
          }
        }
      }
      for (let prop in this.color) {
        let itm = this.color[prop].item;
        let cat = this.color[prop].cat;
        for (let prop2 in itm) {
          if (id === itm[prop2].code) {
            item = this.acopy(itm[prop2]);
            item.cat = cat;
            dat = this.acopy(itm);
          }
        }
      }
      return {
        dat: dat,
        item: item
      };
    },
    categoryLoad (cat) {
      let me = this;
      this.cat = cat;
      axios.get('./static/json/setlist.json').then(function (response) {
        me.setlist = response.data.items;
        me.change(0);
        me.color = 0;
      });
    },
    close () {
      store.commit('setView', 0);
      this.$emit('close');
      let col = Number(this.color);
      let colorCheck = Number(this.$store.state.checkColor);
      if (this.$store.state.checkColor !== col) {
        store.commit('setColor', colorCheck);
      } else if (this.$store.state.checkColor === col) {
        store.commit('setColor', colorCheck);
      }
      setTimeout(function () {
        store.commit('setView', 1);
      }, 1000);
    },
    disabled () {
      if (this.selset !== undefined) {
        if (this.selset !== -1 && this.spanitems.length > 0 && !this.alertW && !this.alertH && !this.alertD) {
          return false;
        } else {
          return true;
        }
      }
    },
    alertShow () {
      this.$modal.show('logout-alert');
    },
    alertHide (n) {
      if (n === 'yes') {
        let url = '/api/logout';
        if (this.config.type === 'b') {
          this.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
        }
        axios.get(this.config.baseURL + url, this.axiosConfig).then(function (response) {
          console.log(response);
          localStorage.removeItem('token');
          localStorage.removeItem('user_id');
          window.location.href = '/login';
        }).catch(function (error) {
          console.log(error);
        });
      }
      this.$modal.hide('logout-alert');
    }
  },
  mounted () {
    let me = this;
    this.$el.parentNode.parentNode.querySelector('.vm--overlay').style.pointerEvents = 'none';
    document.querySelector('body').appendChild(this.$el.parentNode.parentNode);
    axios.get('./static/json/category.json').then(function (response) {
      me.categoryLoad(response.data);
    });
  }
};
</script>

<style lang="stylus" scoped>
.modal {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  header {
    margin: 0;
    padding: 15px 30px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #dddddd;

    button {
      float: right;
      background-color: #2E7C80;
      width: 200px;
      height: 33px;
      border: none;
      border-radius: 5px;
      color: #ffffff;
      font-weight: bold;
      font-size: 14px;

      img {
        display: inline-block;
        vertical-align: middle;
        margin-left: 5px;
        margin-top: -2px;
      }
    }
  }

  .content {
    position: absolute;
    left: 0;
    right: 0;
    top: 62px;
    bottom: 73px;
    padding: 20px 30px;
  }
  .area-warning {
    display: flex;
  }
  .text-desc {
    color: #2e7c80;
    margin: 0;
    font-size: 16px;
  }
  h3 {
    margin: 0;
    font-size: 16px;
  }

  .sizes {
    display: flex;
    padding: 5px 0 15px 0;
    justify-content: center;
    margin-bottom: 0;

    .size {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      flex-wrap: wrap;
      width: 33.3%;

      .tit {
        margin-right: 5px;
      }

      input {
        width: 120px;
        height: 33px;
        text-align: right;
        padding: 0 5px;
        font-weight: bold;
        font-size: 16px;

        &.error {
          border-color: #cc0000;
          background-color: #fff0f0;
        }
      }

      .mm {
        margin-left: 5px;
      }

      .limit {
        width: 100%;
        font-size: 12px;
        font-weight: normal;
        text-align: center;
        color: #cc0000;
        padding-right: 20px;
      }
    }
  }

  .color {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    padding-top: 10px;

    li {
      margin: 0 50px;
      font-weight: normal;

      label {
        overflow: hidden;
        position: relative;

        input {
          position: absolute;
          left: -9999px;
          top: 0;
        }

        input + div {
          border: 2px solid #ffffff;
          border-radius: 3px;
          padding: 2px 5px;
        }

        input:checked + div {
          border: 2px solid #2e7c80;
        }

        input + div span {
          display: inline-block;
          width: 40px;
          height: 20px;
          border: 1px solid #dddddd;
          vertical-align: middle;
          margin-top: -2px;
          margin-right: 10px;
        }
      }
    }

    li:nth-child(2) {
      label {
        input + div span {
          background-color: #000000;
        }
      }
    }
  }

  .tab {
    display: flex;
    justify-content: space-around;
    padding: 15px 0;
    font-weight: bold;

    li {
      border-right: 1px solid #dddddd;
      padding: 3px 27px;
      cursor: pointer;
      color: #999999;

      &.active {
        color: #333333;
      }

      &:first-child {
        border-left: 1px solid #dddddd;
      }
    }
  }

  .itemsWrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 220px;
    bottom: 0;
    background-color: #ffffff;
    overflow-y: auto;
  }

  .items {
    padding: 10px 30px;
    display: flex;
    flex-wrap: wrap;

    .item {
      // width 32.5%
      width: 19%;
      height: 240px;
      background-color: #ffffff;
      margin-right: 1%;
      margin-bottom: 20px;
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #707070;
      position: relative;

      // display flex
      &:nth-child(5n) {
        margin-right: 0;
      }

      .sel {
        display: none;
        border: 3px solid #2e7c80;
        border-radius: 7px;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }

      input {
        position: absolute;
        left: -100px;
      }

      input:checked + .sel {
        display: block;
      }

      figure {
        /* width 40% */
        display: block;
        padding: 0;
        margin: 0;
        line-height: 1;

        img {
          width: 100%;
          user-select: none;
          pointer-events: none;
        }
      }

      dl {
        margin: 0;
        padding: 10px;

        /* width 60% */
        dt {
          font-size: 14px;
          font-weight: bold;
        }

        dd {
          font-size: 12px;
          color: #707070;
          margin: 0;
          padding: 0;
        }
      }
    }
  }

  footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 73px;
    border-top: 1px solid #dddddd;
    padding: 20px 30px;
    text-align: right;

    button {
      background-color: #2E7C80;
      width: 200px;
      height: 33px;
      border: none;
      border-radius: 5px;
      color: #ffffff;
      font-weight: bold;
      font-size: 14px;

      &.logout {
        float: left;
      }

      &.cancel {
        background-color: #999999;
      }

      &[disabled='disabled'] {
        background-color: #aaaaaa;
      }

      img {
        display: inline-block;
        vertical-align: middle;
        margin-left: 5px;
        margin-top: -2px;
      }
    }

    button + button {
      margin-left: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/create/ModalCreate.vue